import type { StyleProp, ViewStyle } from "react-native";
import { StyleSheet, View } from "react-native";

interface PageContainerProps {
  maxWidth?: number | `${number}%`;
  style?: StyleProp<ViewStyle>;
  header?: React.ReactNode;
  children?: React.ReactNode;
}

export const PageContainer = ({
  children,
  maxWidth = 1360,
  header,
  style,
}: PageContainerProps) => (
  <View style={styles.wrapper}>
    {header}
    <View style={[styles.container, { maxWidth }, style]}>{children}</View>
  </View>
);

const styles = StyleSheet.create({
  wrapper: {
    flexGrow: 1,
    alignItems: "center",
  },
  container: {
    paddingHorizontal: 40,
    paddingVertical: 64,
    width: "100%",
  },
});
